import { LanguageDetectorModule } from 'i18next';
import config from '../config';

export const i18nLangKey = 'lang';

export const telusLanguageDetector: LanguageDetectorModule = {
    type: 'languageDetector',
    detect: () => {
        const savedLang = localStorage.getItem(i18nLangKey);
        if (savedLang) {
            return savedLang;
        }

        if (window.location.hostname === config.DOMAIN_FR) {
            return 'fr';
        }
        return 'en';
    },
    init: () => {},
    cacheUserLanguage: (lng: string) => {
        localStorage.setItem(i18nLangKey, lng);
    },
};
